import { LOG_IN, SET_USER_INFO } from 'config/actionTypes'

const initialState = {
  authenticated: false,
  id: '',
  username: '',
  email: '',
  firstName: '',
  lastName: '',
}

export default (state = initialState, action) => {
  switch (action.type) {
    case LOG_IN:
      return {
        ...state,
        authenticated: true,
      }
    case SET_USER_INFO:
      return {
        ...state,
        ...action.userInfo,
      }
    default:
      return state
  }
}
